<template>
    <div id="mapid" :style="{height: height+'px'}">
        <MglMap accessToken="pk.eyJ1IjoiY21vaW5lIiwiYSI6ImNrb2Q0bnZnaDN4MGoycHBnMDFhdnNrNnEifQ.0YUfRSo8wmI9GEGAdqeeeQ"
                :mapStyle="mapStyle"
                :center="[3, 47]"
                :zoom="5"
		            :minZoom="1"
		            :maxZoom="19"
                container="mapid"
                @load="onMapLoaded">
            <MglGeojsonLayer
                type="fill"
                sourceId="regions"
                :source="regions"
                layerId="regions-layer"
                :layer="regionsLayer"
                @click="mouseClick($event, 'regions')"
                @mousemove="mouseMove($event, 'regions')"
                @mouseleave="mouseLeave('regions')"
            />
            <MglGeojsonLayer
                type="fill"
                sourceId="regions"
                :source="regions"
                layerId="regions-contours-layer"
                :layer="regionsContoursLayer"
            />
            
            <MglGeojsonLayer
                type="fill"
                sourceId="cities"
                :source="cities"
                layerId="cities-layer"
                :layer="citiesLayer"
                @click="mouseClick($event, 'cities')"
                @mousemove="mouseMove($event, 'cities')"
                @mouseleave="mouseLeave('cities')"
            />

            <MglGeojsonLayer
                type="fill"
                sourceId="cities"
                :source="cities"
                layerId="cities-contours-layer"
                :layer="citiesContoursLayer"
            />

            <MglFullscreenControl />
            <!-- <MglAttributionControl /> -->
            <MglNavigationControl position="top-right" :showCompass="false"/>
            <MglGeolocateControl position="top-right" />
        </MglMap>
    </div>
</template>

<script>
import Mapbox from "mapbox-gl";
import * as turf from '@turf/turf'
import { MglMap, MglGeojsonLayer, MglAttributionControl, MglNavigationControl, MglScaleControl, MglGeolocateControl, MglFullscreenControl } from "vue-mapbox";
import Vue from 'vue'
import TaxesHomeButton from './TaxesHomeButton'
import TaxesYearChooser from './TaxesYearChooser'

var contoursPaint = {
	"line-width": [
		'case',
		["boolean", ["feature-state", "hover"], false],
		3,
		1
	]
}

var EMPTY_FEATURE_COLLECTION = {
	type: 'FeatureCollection',
	features: []
}

class MyCustomControl {
  constructor(component, props, selectionListener) {
    this.component=component
    this.props=props
    this.selectionListener=selectionListener
  }
  onAdd(map){
    this.map = map;
    this.container = document.createElement('div');
    this.container.className = 'mapboxgl-ctrl mapboxgl-ctrl-group';
    var ComponentClass = Vue.extend(this.component)
    this.instance = new ComponentClass({
      propsData: this.props
    })
    this.instance.$mount()
    if(this.selectionListener) {
      this.instance.$on('selection', this.selectionListener)
    }
    this.container.appendChild(this.instance.$el)
    return this.container;
  }
  onRemove() {
    this.instance.$delete()
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }
}

export default {
  components: {
    MglMap,
    MglGeojsonLayer,
    MglAttributionControl,
    MglNavigationControl,
    MglScaleControl,
    MglGeolocateControl,
    MglFullscreenControl,
    TaxesHomeButton
  },
  data() {
    return {
        height: 0,
        mapStyle: 'https://openmaptiles.geo.data.gouv.fr/styles/osm-bright/style.json',
        regions: {
          generateId: true,
          data: EMPTY_FEATURE_COLLECTION
        },
        regionsLayer: {
          id: 'regions-layer',
          source: 'regions',
          type: 'fill',
          paint: {
            'fill-color': ['get', 'color'],
            /* "fill-outline-color": '#627BC1',
            "fill-opacity": ["case",
              ["boolean", ["feature-state", "hover"], false],
              0.5,
              0
            ] */
            'fill-opacity': 0.5
          }
        },
        regionsContoursLayer: {
          id: 'regions-contours-layer',
          source: 'regions',
          type: 'line',
          maxzoom: 9,
          paint: contoursPaint
        },
        cities: {
          generateId: true,
          data: EMPTY_FEATURE_COLLECTION
        },
        citiesContoursLayer: {
          id: 'cities-contours-layer',
          source: 'cities',
          type: 'line',
          paint: contoursPaint
        },
        citiesLayer: {
          id: 'cities-layer',
          source: 'cities',
          type: 'fill',
          paint: {
            'fill-color': ['get', 'color'],
            'fill-opacity': 0.5
          }
        },
        year: '2019'
    };
  },
  created() {
    // We need to set mapbox-gl library here in order to use it in template
    this.mapbox = Mapbox;
    this.map = null;
    this.hoveredStateId = null;
    this.src= 'all';
    this.event = null;
    window.addEventListener("resize", this.myEventHandler);
    this.myEventHandler();
    this.refresh();
  },
  methods: {
    myEventHandler() {
      this.height=window.innerHeight;
    },
    mouseClick(e, src) {
      this.src=src;
      var event=e.mapboxEvent;
      if(this.src==="all") {
        // no-op
      } else if(this.src==="regions") {
        this.region=event.features[0].properties.code
      } else {
        var props=event.features[0].properties;
        this.cityCode=props.code
        this.lngLat=event.lngLat
      }
      this.refresh();
    },
    refresh() {
      if(this.src==="all" || this.src==="regions") {
        this.axios.all([
          this.axios.get('/donneesgeo/departements-100m.geojson'),
          this.axios.get(`db/${this.year}/all.json`)
        ]).then((response) => {
          var regions=response[0].data;
          var detail=response[1].data;
          regions.features.forEach(it => {
              it.properties.color = '#808080';
              it.properties.percentage = '[N/C]';
              if(it.properties.code) {
                  if(detail[it.properties.code]) {
                    it.properties.color = detail[it.properties.code].color
                    it.properties.percentage = detail[it.properties.code].percentage
                  }
                }
          })
          this.regions.data=regions;
        })
      }
      if(this.src==="regions") {
        this.axios.all([
            this.axios.get(`https://geo.api.gouv.fr/departements/${this.region}/communes?geometry=contour&format=geojson&type=commune-actuelle`),
            this.axios.get(`db/${this.year}/${this.region}.json`)
          ]).then((response) => {
            var cities=response[0].data;
            var detail=response[1].data;
            cities.features.forEach(it => {
                it.properties.color = '#808080';
                it.properties.percentage = '[N/C]';
                if(it.properties.code) {
                    if(detail[it.properties.code]) {
                      it.properties.color = detail[it.properties.code].color
                      it.properties.percentage = detail[it.properties.code].percentage
                    }
                  }
            })
            this.cities.data=cities;
            this.$nextTick(() => {
              var bbox = turf.bbox(cities)
              this.map.fitBounds(bbox, { padding: 20,
                animate: true,
                duration: 1000})
            })
          })
        } else if(this.src!=="all") {
          var props=this.cities.data.features.find(elt => elt.properties.code==this.cityCode).properties;
          new this.mapbox.Popup()
            .setLngLat(this.lngLat)
            .setHTML('<h3>'+props.codesPostaux.join(", ") +' '+props.nom+'</h3><p>'+props.percentage+'%</p>')
            .addTo(this.map)
        }
    },
    mouseMove(e, src) {
      var canvas = this.map.getCanvas()
	    canvas.style.cursor = 'pointer'
      var event=e.mapboxEvent;

      if (event.features.length > 0) {
        if (this.hoveredStateId) {
          this.map.setFeatureState({ source: 'regions', id: this.hoveredStateId }, { hover: false }); // clean all sources to prevent error
          this.map.setFeatureState({ source: 'cities', id: this.hoveredStateId }, { hover: false }); // clean all sources to prevent error
        }
        this.hoveredStateId = event.features[0].id;
        this.map.setFeatureState({ source: src, id: this.hoveredStateId },
          { hover: true });
      }
    },
    mouseLeave(src) {
      var canvas = this.map.getCanvas()
	    canvas.style.cursor = ''

      if (this.hoveredStateId !== null) {
        this.map.setFeatureState({ source: src, id: this.hoveredStateId }, { hover: false });
      }
    },
    onMapLoaded(event) {
      // in component
      this.map = event.map;
      this.map.addControl(new MyCustomControl(TaxesHomeButton), 'top-left');
      this.map.addControl(new MyCustomControl(TaxesYearChooser, { selection: this.year }, (e) => this.year = e), 'top-left');
    }
  },
  watch: {
    year: function (val) {
      this.refresh();
    }
  }
}
</script>

<style>
h3 {
  font-size: 1rem !important;
  font-weight: bold !important;
}
</style>